import Grid from "./grid"

export type { GridProps } from "./interface"

export default Grid
